// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5bcaa7c0","239":"c0be583e","453":"0ffb0cc6","455":"4ec6382c"}[chunkId] + ".chunk.js";
};